export const getAuditTrailsUrl = () => 'agency/audit_trails';
